export default "/dist/f5145665c186545eedbbd27443544fe6.png";